import React from 'react'
import * as Header from "./headerStyles"

export default function NormalMenu({mounted}) {
    return (
        <Header.Group>
            <Header.ContainerList>
                {!mounted ? 
                <>
                    <Header.Item href="#about">
                        <Header.Number>01.</Header.Number>
                        About
                    </Header.Item>
                    {/* <Header.Item href="#experience">
                        <Header.Number>02.</Header.Number>
                        Experience
                    </Header.Item>
                    <Header.Item href="#skills">
                        <Header.Number>03.</Header.Number>
                        Skills
                    </Header.Item> */}
                    <Header.Item href="#projects">
                        <Header.Number>02.</Header.Number>
                        Projects
                    </Header.Item>
                    <Header.Item href="#contact">
                        <Header.Number>03.</Header.Number>
                        Contact
                    </Header.Item>
                </>
                :
                <>
                    <Header.ItemMounted href="#about">
                        <Header.Number>01.</Header.Number>
                        About
                    </Header.ItemMounted>
                    {/* <Header.ItemMounted href="#experience">
                        <Header.Number>02.</Header.Number>
                        Experience
                    </Header.ItemMounted>
                    <Header.ItemMounted href="#skills">
                        <Header.Number>03.</Header.Number>
                        Skills
                    </Header.ItemMounted> */}
                    <Header.ItemMounted href="#projects">
                        <Header.Number>02.</Header.Number>
                        Projects
                    </Header.ItemMounted>
                    <Header.ItemMounted href="#contact">
                        <Header.Number>03.</Header.Number>
                        Contact
                    </Header.ItemMounted>
                </>
                }
            </Header.ContainerList>
        </Header.Group>
    )
}
